import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

window.addEventListener("error", function(event) {
  var erro = {
    mensagem: event.message,
    arquivo: event.filename,
    linha: event.lineno,
    coluna: event.colno,
    stack: (event.error && event.error.stack) || "sem stack",
    data: new Date().toISOString()
  };
  try { localStorage.setItem("ultimo_erro_clickhub", JSON.stringify(erro, null, 2)); } catch (e) {}
  document.body.innerHTML = "<pre style=\"color:#0f0;background:#000;padding:20px;font-size:13px;white-space:pre-wrap;\">" + JSON.stringify(erro, null, 2) + "</pre>";
});

window.addEventListener("unhandledrejection", function(event) {
  var erro = {
    tipo: "Promise rejeitada sem tratamento",
    razao: String(event.reason),
    stack: (event.reason && event.reason.stack) || "sem stack",
    data: new Date().toISOString()
  };
  try { localStorage.setItem("ultimo_erro_clickhub", JSON.stringify(erro, null, 2)); } catch (e) {}
  document.body.innerHTML = "<pre style=\"color:#f00;background:#000;padding:20px;font-size:13px;white-space:pre-wrap;\">" + JSON.stringify(erro, null, 2) + "</pre>";
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
